@if (errorInfo(); as error) {
<div class="generic-error">
  <div class="generic-error__content">
    <img
      [src]="error.icon"
      [alt]="error.altKey | translate"
      class="no-access-icon"
    />

    <div class="caption-container">
      <h3 class="error-title">{{ error.titleKey | translate }}</h3>
      <p class="error-caption">{{ error.descriptionKey | translate }}</p>
      @if (error.description2PreLinkKey) {
      <p class="error-caption">
        {{ error.description2PreLinkKey | translate }}
      </p>
      }
    </div>
  </div>
</div>
}
